export enum EnumCacheKeys {
  RC_PPT_SITE_MAP = 'RC_PPT_SITE_MAP',
  Help_RetirementPlanDocuments = 'Help_RetirementPlanDocuments'
}

export type IEnumCacheKeys = keyof typeof EnumCacheKeys;
